import { Outlet, useLocation } from 'react-router-dom';
import { Box, Toolbar, useMediaQuery } from "@mui/material";
import Breadcrumbs from '../../../../components/@extended/Breadcrumbs';
import Header from './Header';
import Sidebar from './Sidebar';
import { memo, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openDrawer } from '../../../../store/reducers/menu';
import menuConfig from '../../../config/menu.config';
// import ModuleHeader from './ModuleHeader';

const PortalLayout = () => {
  // const bmr_modules = useSelector((state) => state.loginData).bmr_modules;
  // const singleModuleAccess = bmr_modules.length == 1 ? true : false;
  const dispatch = useDispatch();
  const location = useLocation();
  const { drawerOpen } = useSelector((state) => state.menu);
  const matchesLg = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  // Memoize the first segment to prevent unnecessary recalculations
  const firstSegment = useMemo(() =>
    location.pathname.split('/')[2],
    [location.pathname]
  );

  // Initial drawer state setup
  useEffect(() => {
    dispatch(openDrawer({ drawerOpen: false }));
  }, [dispatch]);

  // Memoize the main box styles
  const mainBoxStyles = useMemo(() => ({
    maxWidth: "100%",
    width: drawerOpen
      ? { xs: "100%", lg: "70%", md: "70%" }
      : { xs: "100%", lg: "100%", md: "100%", sm: "100%" },
    flexGrow: 1,
    height: "100vh",
  }), [drawerOpen]);

  const handleMiniDrawerToggle = () => {
    dispatch(openDrawer({ drawerOpen: !matchesLg ? false : !drawerOpen }));
  };

  const handleDrawerToggle = () => {
    const menuItem = findMenuItemBySegment(firstSegment);
    if (menuItem) {
      dispatch(openDrawer({ drawerOpen: !matchesLg ? false : !drawerOpen }));
    }
  };
  return (
      <Box className='relative' sx={{ display: "flex", width: "100%" }}>
        {/* {singleModuleAccess ?
          <ModuleHeader />
          : */}
          <>
            <Header
              open={drawerOpen}
              handleDrawerToggle={handleMiniDrawerToggle}
            />
            <Sidebar
              open={drawerOpen}
              handleDrawerToggle={handleDrawerToggle}
            />
          </>
        {/* } */}
        <Box component="main" sx={mainBoxStyles}>
          <Toolbar />
          <Breadcrumbs navigation={{ items: [menuConfig] }} title />
          <Outlet />
        </Box>
      </Box>
  );
};

// Utility function to find menu item by segment
const findMenuItemBySegment = (segment) => {
  for (const item of menuConfig.children) {
    if (item?.subChildren) {
      const found = item.subChildren.find(subItem => subItem.id === segment);
      if (found) {
        return {
          ...found,
          parent: item.title,
          parentId: item.id
        };
      }
    }
  }
  return null;
};

export default memo(PortalLayout);
